import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import './assets/styles.css'
import ToastPlugin from './plugins/toast';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import CanvasJSChart from '@canvasjs/vue-charts';

const app = createApp(App)

app.use(CanvasJSChart);
app.component('VueDatePicker', VueDatePicker)

app.use(router)
app.use(store);
app.use(ToastPlugin);
app.mount('#app')
